import React, { useState } from 'react';
import ConversationModal from './ConversationModal';
import InviteParticipantsModal from '../InviteParticipantsModal';

interface ConversationModalWithInviteProps {
  [key: string]: any;
}

const ConversationModalWithInvite: React.FC<
  ConversationModalWithInviteProps
> = (props) => {
  const [inviteModalOpen, setInviteModalOpen] = useState(false);

  const handleOpenAddParticipant = () => {
    setInviteModalOpen(true);
  };

  const handleCloseInviteModal = () => {
    setInviteModalOpen(false);
  };

  // Override the openAddParticipant prop to use our new modal
  const modifiedProps = {
    ...props,
    openAddParticipant: handleOpenAddParticipant,
  };

  return (
    <>
      <ConversationModal {...modifiedProps} />
      <InviteParticipantsModal
        open={inviteModalOpen}
        onClose={handleCloseInviteModal}
        conversationId={props.groupId}
      />
    </>
  );
};

export default ConversationModalWithInvite;
